export default __webpack_public_path__ + "static/media/about-icon2.6a498384.svg";